

<!-- Question -->
<div class="c-survey__section survey-question">
  @for (text of questionDetails.QuestionText; track text) {
    <h2 [attr.headerid]="text" class="c-survey__question is-multi-question">{{ text | translate }}</h2>
  }
</div>

<div class="c-survey__section survey-choices">
  <img style="max-height: 350px; padding-bottom: 50px;" src={{maskPath}} />
  <div class="c-sleepiness-options">
    <div class="o-layout o-layout--small">
      @for (star of questionDetails.PossibleAnswers; track star; let i = $index) {
        <div class="o-layout__item u-1/5">
          <div class="c-sleep-icon">
            <span class="material-icons star-icon" [attr.starId]="i+1" (click)="answerSelected(star, i+1)">{{showIcon(i)}}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
